"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseShippingRule = void 0;
const utils_1 = require("../utils");
class BaseShippingRule {
    constructor(props) {
        this.props = props;
        this.selectedProductIds = [];
        this.selectedProductIds = props.selectedProducts.map((selectedProduct) => selectedProduct.id);
    }
    /**
     * Get selected products from promotion
     */
    get selectedProducts() {
        return this.props.selectedProducts;
    }
    /**
     * Get chosen shipping method
     * @deprecated
     * Use chosenShippingIds
     */
    get chosenShippingMethod() {
        var _a;
        return (_a = this.props) === null || _a === void 0 ? void 0 : _a.method;
    }
    /**
     * Get chosen shipping ids that qualify for shipping rule
     */
    get chosenShippingIds() {
        return this.props.shippingIds || [];
    }
    /**
     * Get shipping rule properties
     */
    getProperties() {
        return this.props;
    }
    /**
     * Is matched selected shipping method
     * @param cart
     * @returns {boolean}
     */
    isMatchedSelectedShippingMethod(cart) {
        if ((0, utils_1.isMatchedSelectedShippingByChosenShippingIdsAndSelectedShippingId)(cart, this.chosenShippingIds)) {
            return true;
        }
        // Backward compatible
        return (0, utils_1.isMatchedSelectedShippingByChosenShippingMethod)(cart, this.chosenShippingMethod);
    }
}
exports.BaseShippingRule = BaseShippingRule;
//# sourceMappingURL=base.js.map